// extracted by mini-css-extract-plugin
export default {"container":"A11y_container__S22Re","a11y":"A11y_a11y__coCsG","controls":"A11y_controls__36Mg3","option":"A11y_option__s7jeH"};